import { memo, useCallback } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryHeader.module.scss";
import { ISociometryClassInfo } from "shared/types/sociometry";
import { useHistory } from "react-router-dom";
import { SociometryClassInfo } from "../SociometryClassInfo/SociometryClassInfo";

interface SociometryHeaderProps {
    className?: string;
    classInfo: ISociometryClassInfo | null;
    currentQuestionIndex: number;
    totalQuestions: number;
}

export const SociometryHeader = memo((props: SociometryHeaderProps) => {
    const { className, classInfo, currentQuestionIndex, totalQuestions } = props;
    const history = useHistory();

    const handleGoBack = useCallback(() => {
        history.push("/tests");
    }, [history]);

    return (
        <header className={classNames(cls.sociometryHeader, {}, [className])}>
            <button onClick={handleGoBack} className={cls.backButton} aria-label="Go back" />
            {classInfo && <SociometryClassInfo classNumber={classInfo.number} classLetter={classInfo.letter} />}
            <div className={cls.score}>
                <p>{currentQuestionIndex + 1}</p>
                <p className={cls.scoreTotal}>{totalQuestions}</p>
            </div>
        </header>
    );
});

SociometryHeader.displayName = "SociometryHeader";
